import { render, staticRenderFns } from "./compound.vue?vue&type=template&id=7817a013&scoped=true"
import script from "./compound.vue?vue&type=script&lang=js"
export * from "./compound.vue?vue&type=script&lang=js"
import style0 from "./compound.vue?vue&type=style&index=0&id=7817a013&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7817a013",
  null
  
)

export default component.exports